module.exports = __webpack_public_path__ + "img/outlet-white.ba3886c5.svg";